import _ from 'lodash';
import Api from '@/api';
import * as types from '../mutation-types';

const state = {
  // 最新商品（用於首頁）
  newArrivals: [],
  // 推薦商品（用於首頁）
  recommends: [],
  // 熱銷商品（用於首頁）
  hots: [],
  // 特價商品（用於首頁）
  sales: [],
  // 普通商品（用於首頁）
  addPurchases: [],
  generals: [],
  generalsPagination: null,
  // 商品詳細（此對象包含所有已瀏覽過的商品詳細）
  products: {},
  // 商品列表，用於商品列表頁
  list: [],
  brands: [],
  pagination: null,
  categories: [],
  viewLogs: [],
  source: [],
  fee: {},
  coupons: {},
};

const getters = {
  productDetail: s => id => _.get(s, ['products', id]),
  brandsByFistLatter: (s) => {
    const brands = {};
    for (let i = 65; i <= 90; i++) {
      const latter = String.fromCharCode(i);
      brands[latter] = [];
    }
    brands['#'] = [];

    _.forEach(s.brands, (brand) => {
      let fistLatter = brand.name.substr(0, 1).toUpperCase();
      if (!/[A-Z]/.test(fistLatter)) {
        fistLatter = '#';
      }
      // if (!_.has(brands, fistLatter)) {
      //   brands[fistLatter] = [];
      // }
      brands[fistLatter].push(brand);
    });
    return brands;
  },
};

/* eslint no-shadow:0 */
const actions = {
  fetchFee({ commit }) {
    return Api.shippingAddress.getFee().then(({ data: response }) => {
      commit(types.RECEIVE_FEE, response);
    });
  },
  fetchProducts({ commit, dispatch }, params = {}) {
    dispatch('wait/start', 'fetchProducts');
    return Api.product.get(params).then(({ data: response }) => {
      // const totle = response.meta.pagination.total;
      // if (!~totle) {
      //
      // }

      commit(types.RECEIVE_PRODUCTS, response);
      dispatch('wait/end', 'fetchProducts');
    });
  },
  // 獲取最新商品
  fetchNewArrival({ rootState, commit }) {
    return Api.product.get({ type: 'new-arrival', perpage: 8 }).then(({ data: response }) => {
      if (rootState.app.currency !== response.data[0].currency) {
        _.forEach(response.data, (item) => {
          item.currency = rootState.app.currency;
        });
      }
      commit(types.RECEIVE_PRODUCTS_NEW_ARRIVAL, response.data);
    });
  },
  // 獲取特價商品
  fetchSale({ commit }) {
    return Api.product.get({ type: 'sales', perpage: 8 }).then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCTS_SALE, response.data);
    });
  },
  // 獲取熱銷商品
  fetchHot({ commit }) {
    return Api.product.get({ type: 'hot-sale', perpage: 8 }).then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCTS_HOT, response.data);
    });
  },
  // 獲取推薦商品
  fetchRecommend({ commit }, params = {}) {
    params = { type: 'recommend', ...params };
    return Api.product.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCTS_RECOMMEND, response.data);
    });
  },
  // 獲取推薦商品
  fetchAddPurchase({ commit }, params = {}) {
    params = { type: 'add-purchase', ...params };
    return Api.product.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCTS_ADD_PURCHASE, response.data);
    });
  },
  // 获取普通商品
  fetchGeneral({ commit, state, dispatch }, page = 1) {
    if (state.generalsPagination === null || state.generalsPagination.current_page !== page) {
      if (!state.generals.length) {
        dispatch('wait/start', 'fetchGeneral');
      }
      return Api.product.get({
        type: 'general', perpage: 12, sort: 'sort_index', page,
      }).then(({ data: response }) => {
        commit(types.RECEIVE_PRODUCTS_GENERAL, response);
        dispatch('wait/end', 'fetchGeneral');
      });
    }
    return Promise.resolve();
  },
  // 獲取商品詳細
  getProductById({ commit }, id) {
    if (!_.has(state, ['products', id])) {
      return Api.product.getById(id).then(({ data: response }) => {
        commit(types.RECEIVE_PRODUCTS_DETAIL, response.data);
      });
    }
    return Promise.resolve();
  },
  fetchCategories({ commit }) {
    // if (!s.categories.length) {
    return Api.product.getCategories().then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCT_CATEGORIES, response);
    });
    // }
    // return Promise.resolve();
  },
  fetchProductBrands({ commit }, params = {}) {
    return Api.brand.get({ ...params, product: true }).then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCT_BRANDS, response.data);
    });
  },
  fetchSource({ commit }) {
    return Api.product.getOrginPlace().then(({ data: response }) => {
      commit(types.RECEIVE_PRODUCT_SOURCE, response);
    });
  },
  fetchCoupon({ commit }) {
    return Api.product.getCouponList().then(({ data: response }) => {
      commit(types.COUPON_LIST, response);
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.COUPON_LIST](s, data) {
    s.coupons = data;
  },
  [types.RECEIVE_PRODUCT_SOURCE](s, data) {
    s.source = data;
  },
  [types.RECEIVE_PRODUCTS_NEW_ARRIVAL](s, data) {
    s.newArrivals = data;
  },
  [types.RECEIVE_PRODUCTS_SALE](s, data) {
    s.sales = data;
  },
  [types.RECEIVE_PRODUCTS_RECOMMEND](s, data) {
    s.recommends = data;
  },
  [types.RECEIVE_PRODUCTS_ADD_PURCHASE](s, data) {
    s.addPurchases = data;
  },
  [types.RECEIVE_PRODUCTS_HOT](s, data) {
    s.hots = data;
  },
  [types.RECEIVE_PRODUCTS_DETAIL](s, data) {
    s.products = { ...s.products, [data.id]: data };
  },
  [types.RECEIVE_PRODUCTS_GENERAL](s, response) {
    s.generals = [...s.generals, ...response.data];
    s.generalsPagination = response.meta.pagination;
  },
  [types.RECEIVE_PRODUCTS](s, response) {
    s.list = response.data;
    s.pagination = response.meta.pagination;
  },
  [types.RECEIVE_PRODUCT_CATEGORIES](s, data) {
    s.categories = [...data];
  },
  [types.RECEIVE_PRODUCT_BRANDS](s, data) {
    s.brands = [...data];
  },
  [types.RECEIVE_FEE](s, data) {
    s.fee = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
